import clsx from 'clsx';

type TextInputProps = {
    value?: string;
    onInput: (value: any) => void;
    placeholder?: string;
    name?: string;
    hasErrors?: boolean;
    autoWidth?: boolean;
    width?: string;
    monospace?: boolean;
};

export const TextInput = (props: TextInputProps) => (
    <input
        value={props.value}
        onInput={props.onInput}
        placeholder={props.placeholder}
        name={props.name}
        class={clsx(
            'p-4 rounded-[0.8rem] text-normal font-normal text-darkGray',
            props.hasErrors ? 'border border-[#d25960]' : 'border border-[#707070]',
            props.monospace ? 'font-mono' : 'font-atos-regular',
            props.autoWidth ? 'w-auto grow' : 'w-full',
        )}
        style={props.width ? { 'max-width': props.width } : undefined}
    />
);
